export default __webpack_public_path__ + "static/HomeBGImage-194e9227002b7af0aeacf1ac78b346e8.jpeg";